"use strict";
//Wrapping all JavaScript code into a IIFE function for prevent global variables creation
(function ($) {

    var $body = $('body');
    var $window = $(window);

    //  Flexslider custom stars here

    //function that initiating template plugins on window.load event
    $(document).ready(function () {
        documentReadyInit();
    });

    $window.on('load', function () {
        windowLoadInit();
    }); //end of "window load" event


    function windowLoadInit() {
        //////////////
        //flexslider//
        //////////////
        if ($().flexslider) {
            var $introSlider = $(".page_slider .flexslider");
            $introSlider.each(function (index) {
                var $currentSlider = $(this);
                var data = $currentSlider.data();
                var nav = (data.nav !== 'undefined') ? data.nav : true;
                var dots = (data.dots !== 'undefined') ? data.dots : true;
                var speed = (data.speed !== 'undefined') ? data.speed : 7000;

                $currentSlider.flexslider({
                    customDirectionNav: $(".custom-navigation a"),
                    animation: "fade",
                    pauseOnHover: true,
                    useCSS: true,
                    controlNav: false,
                    directionNav: nav,
                    prevText: "",
                    nextText: "",
                    smoothHeight: false,
                    slideshowSpeed: speed,
                    animationSpeed: 600,
                    start: function (slider) {
                        flexSliderCountNav();
                        slider.find('.intro_layers').children().css({ 'visibility': 'hidden' });
                        slider.find('.flex-active-slide .intro_layers').children().each(function (index) {
                            var self = $(this);
                            var animationClass = !self.data('animation') ? 'fadeInRight' : self.data('animation');
                            setTimeout(function () {
                                self.addClass("animated " + animationClass);
                            }, index * 250);
                        });
                    },
                    after: function (slider) {
                        flexSliderCountNav();
                        slider.find('.flex-active-slide .intro_layers').children().each(function (index) {
                            var self = $(this);
                            var animationClass = !self.data('animation') ? 'fadeInRight' : self.data('animation');
                            setTimeout(function () {
                                self.addClass("animated " + animationClass);
                            }, index * 250);
                        });
                    },
                    end: function (slider) {
                        slider.find('.intro_layers').children().each(function () {
                            var self = $(this);
                            var animationClass = !self.data('animation') ? 'fadeInRight' : self.data('animation');
                            self.removeClass('animated ' + animationClass).css({ 'visibility': 'hidden' });
                            // $(this).attr('class', '');
                        });
                    },

                })
                //wrapping nav with container - uncomment if need
                // .find('.flex-control-nav')
                // .wrap('<div class="container nav-container"/>')
            }); //.page_slider flex slider

            $(".flexslider").each(function (index) {
                var $currentSlider = $(this);
                //exit if intro slider already activated
                if ($currentSlider.find('.flex-active-slide').length) {
                    return;
                }
                $currentSlider.flexslider({
                    animation: "fade",
                    useCSS: true,
                    controlNav: true,
                    directionNav: false,
                    prevText: "",
                    nextText: "",
                    smoothHeight: false,
                    slideshowSpeed: 5000,
                    animationSpeed: 800,
                })
            });
        }






    }//eof windowLoadInit

    //  Flexslider custom ends here
    function flexSliderCountNav() {
        if (!document.querySelector('.flexslider-count-nav')) {
            return true
        }

        let nav = document.querySelector('.flexslider-count-nav');
        let prevNavCounter = nav.querySelector('.flex-prev').querySelector('.flex-counter');
        let nextNavCounter = nav.querySelector('.flex-next').querySelector('.flex-counter');
        let slider = nav.closest('.page_slider').querySelector('.flexslider');
        let slidesLength = slider.querySelectorAll('.slide').length;
        let index = [...slider.querySelectorAll('.slide')].findIndex(function (item) {
            return item.classList.contains('flex-active-slide')
        });

        let nextIndex = function () {
            let next = index + 2;
            if (next > slidesLength) next = 1;
            return next
        }

        let prevIndex = function () {
            let prev = index;
            if (prev === 0) prev = slidesLength
            return prev
        }

        prevNavCounter.innerHTML = `0${prevIndex()} / 0${slidesLength}`
        nextNavCounter.innerHTML = `0${nextIndex()} / 0${slidesLength}`
    }

    //function that initiating template plugins on window.load event
    function documentReadyInit() {

        //background image teaser and sections with half image bg
        //put this before prettyPhoto init because image may be wrapped in prettyPhoto link
        $(".bg_teaser, .cover-image").each(function () {
            var $element = $(this);
            var $image = $element.find("img").first();
            if (!$image.length) {
                $image = $element.parent().find("img").first();
            }
            if (!$image.length) {
                return;
            }
            var imagePath = $image.attr("src");
            $element.css("background-image", "url(" + imagePath + ")");
            var $imageParent = $image.parent();
            //if image inside link - adding this link, removing gallery to preserve duplicating gallery items
            if ($imageParent.is('a')) {
                $element.prepend($image.parent().clone().html(''));
                $imageParent.attr('data-gal', '');
            }
        });
    }

    // Owl Carousel
    $('.impact-carousel').owlCarousel({
        loop:true,
        margin:30,
        dots:true,
        nav:false,
        
        responsive:{
            0:{
                items:1
            },
            600:{
                items:3
            },
            1000:{
                items:3
            }
        }
    })

    $('.support-carousel').owlCarousel({
        loop:true,
        dots:true,
        nav:false,
        merge:true,
        stagePadding: 400,
        responsive:{
            
            0:{
                items:1,
                stagePadding: 0,
                margin:0,

            },
            600:{
                items:1,
                margin:30,
            },
            1000:{
                items:1,
                margin:30,
            }
        }
    })


    // AOS
    AOS.init();
 
})(jQuery);